import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment-timezone';
import paymentTypes from '../catalogs/paymentTypes';

import { ALL, PROCESSED, PURCHASE } from '../constants/documents';

const fetchDateFormat = 'YYYY-MM';

const initialState = {
  filters: {
    date1: moment().add(-2, 'month').format(fetchDateFormat),
    date2: moment().format(fetchDateFormat),
    type: PURCHASE,
    processed: PROCESSED,
    pay: paymentTypes.ALL,
    min: 0,
    max: 0,
    limit: 25,
    supplier: ALL
  }
};

export const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    setFilterValues: (state, action) => {
      for (const key in action.payload) {
        state.filters[key] = action.payload[key];
      }
    },
    resetFilterValues: () => initialState
  }
});

export const { setFilterValues, resetFilterValues } = documentsSlice.actions;
export default documentsSlice.reducer;
